"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstMapEntry = void 0;
exports.firstMapEntry = (map) => Array.from(map)[0];
//# sourceMappingURL=first-map-entry.js.map